import { render, staticRenderFns } from "./volleyball-icon.vue?vue&type=template&id=4540fc03"
import script from "./volleyball-icon.vue?vue&type=script&lang=js"
export * from "./volleyball-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports